import React from 'react';
import { Switch } from './SettingRow';
import { SectionBlock } from './TwoColumnLayout';

interface Setting {
	value: any;
	changeAppliedDate?: string;
}

interface Props {
	title: string;
	setting: Partial<Setting>;
	variable: string;
	description?: string;
	onChange: (value: any) => void;
	disabled: boolean;
	checked: any;
	updating: boolean;
	voicemailMsisdn?: string;
}

export const ChoiceSwitch: React.FC<Props> = (props: Props) => {
	return (
		<SectionBlock>
			<Switch
				title={props.title}
				updating={props.updating}
				disabled={props.disabled}
				infoText={props.setting.changeAppliedDate ? `Asetusta päivitetään. Päivittyy ${props.setting.changeAppliedDate}` : 'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
				checked={props.checked}
				onChange={(checked: boolean) => props.onChange({ [props.variable]: { name: props.variable, value: checked } })}
				voicemailMsisdn={props.voicemailMsisdn}
			>
				{props.description}
			</Switch>
		</SectionBlock>
	);
};
